import React from 'react';
import { Button } from '@mui/material';
import IntlMessage from '../../IntlMessage';
import BaseConvention from '../convention';
import DialogComponent from '../../dialogs/DialogComponent';


export type ConventionDialogProps = {
    show: boolean,
    onClose: () => void,
    onAccept?: () => void,
}

const ConventionDialog = ({ show, onClose, onAccept }: ConventionDialogProps) => {
    return (
        <DialogComponent
            id="cgu"
            maxWidth="md"
            show={show}
            disableBackdropClick
            onClose={() => onClose()}
            title={""}
        >
            <BaseConvention />
            <div className="col-md-12 mt-2 d-flex justify-content-end">
                <Button
                    color='secondary'
                    variant='contained'
                    className='text-inherit'
                    onClick={() => onClose()}
                >
                    <IntlMessage id='button.cancel' />
                </Button>
                { onAccept && (
                    <Button
                        color='primary'
                        variant='contained'
                        className='text-inherit'
                        style={{ marginLeft: 10 }}
                        onClick={() => onAccept()}
                    >
                        <IntlMessage id='convention.accept' />
                    </Button>
                )}
            </div> 
        </DialogComponent>
    );
};

export default ConventionDialog;
